export default __webpack_public_path__ + "static/media/portfolio-112.f565ff8e.jpg";